let elHeaderSearchform = document.getElementById('header_searchform'), i;
let elSearchToggle = document.querySelectorAll('.search-for-it');
console.log(elHeaderSearchform);

for (i = 0; i < elSearchToggle.length; ++i) {
  elSearchToggle[i].addEventListener("click", function(){elHeaderSearchform.classList.toggle('open');});
}
